<!--suppress HtmlUnknownAttribute -->
<script lang="ts">
    interface Props {
        viewBox?: string;
        width?: string;
        height?: string;
        fill?: string;
        background?: string;
        style?: string;
        right?: string;
        top?: string;
        close?: boolean;
        onClose: () => void;
    }

    // prettier-ignore
    let {
        viewBox = '0 0 20 20',
        width,
        height,
        fill,
        background,
        style,
        right = '1rem',
        top = '1rem',
        close = false,
        onClose,
    }: Props = $props()

</script>

<button id="close-btn"
        onclick={onClose}
        style:right
        style:top
>
    {#if close}
        <span>Close</span>
    {/if}
    <svg xmlns="http://www.w3.org/2000/svg" {width} {height} {viewBox} {fill} style:background {style}>
        <title> close </title>
        <path d="M4.34 2.93l12.73 12.73-1.41 1.41L2.93 4.35z"/>
        <path d="M17.07 4.34L4.34 17.07l-1.41-1.41L15.66 2.93z"/>
    </svg>
</button>


<!--suppress CssUnresolvedCustomProperty -->
<style>
    button {
        position: absolute;
        margin: 0;
        padding: 0;
        background: transparent;
        cursor: pointer;
        display: flex;
        align-items: center;
        z-index: var(--z-index-close-x);
    }

    span {
        margin-right: .4rem;
        font-size: .95rem;
        line-height: 1;
    }

    button:hover svg {
        fill: var(--color-main);
    }

    button:focus {
        background: var(--color-light);
    }
</style>